import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators'
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import { VesselClfPopupModel } from '../../../src/models/vessel-clf-popup-model';
import { VesselPlanningModel, VoyagePlan } from '../../../src/models/vessel-planning-model';
import { WRStatus } from '../../voyage-suggested-routes/src/helper';
import { VoyageToastManager } from '../../voy-toast/src/voy-toast-manager';
import { WRMessageTypes } from '../../../src/services/types/vessel-notifications-services.types';

type Reasons<T extends string> = {
    [key in T]: string;
};

export const WR_UPDATE_POPUP_VISBILITY_EVENT = 'wr-update-popup-visible'
export const WR_UPDATE_POPUP_CANCEL_CLICKED = 'wr-update-popup-cancel-clicked'
export const WR_UPDATE_POPUP_SUBMIT_CLICKED = 'wr-update-popup-submit-clicked'

const WR_REJECT_DESCRIPTION = `As you are requesting for weather routing update, please provide a reason below.`

const WR_REJECT_TITLE = 'Reason for WR update request'

const SUCCES_MODAL_CONTENT = `your feedback has been submitted successfully`

const WR_REJECT_FOOTER_DESCRIPTION = `kindly update your voyage plan if needed and set it to approved
in order to inform WNI and Voyage Execution team about your intensions`



@customElement('wr-update-clf-popup')
export class VesselClfReasonPopup extends LitElement {

    constructor(){
        super();
        this._setPopupVisibility = this._setPopupVisibility.bind(this)
        this._onSubmit = this._onSubmit.bind(this)
        this._onCancel = this._onCancel.bind(this)
    }

    connectedCallback(): void {
        super.connectedCallback()
        VesselClfPopupModel!.addEventListener(
            WR_UPDATE_POPUP_VISBILITY_EVENT,
            (e: Event) => this._setPopupVisibility(e),
        )
    }

    disconnectedCallback(): void {
        super.disconnectedCallback()
        VesselClfPopupModel!.removeEventListener(
            WR_UPDATE_POPUP_VISBILITY_EVENT,
            (e: Event) => this._setPopupVisibility(e),
        )
    }

    static get styles() {
        return [
            css`
                :host {
                    font-family: MaerskText;
                    z-index: 9999;
                }
                .comment {
                    font-family: 'MaerskText';
                    width: 380px;
                    height: 70px;
                    border: 1px solid #c4c4cd;
                    line-height: 20px;
                    resize: vertical;
                    border-radius: 6px;
                }
                .comment[errorComment] {
                    border-color: var(--voyage-alarm-red);
                }
                #alarm-popup .popup {
                    width: 400px;
                    max-width: 80vw;
                    height: 40vh;
                    padding: 0 24px;
                }

                #success-topContainer {
                    padding: 24px;
                    width: 392px;
                    display: grid;
                    align-items: center;
                    justify-items: start;
                    column-gap: 15px;
                    row-gap: 16px;
                    border-bottom: 1px solid var(--neutrals-grey-07);
                }
                .success-innerContainer {
                    display: flex;
                    background-color: #c5e5c2;
                    padding: 20px;
                    border-radius: 6px;
                }
                .content {
                    margin-left: 20px;
                }
                .max-width-container h2 {
                    margin-top: 0px;
                }
                .name {
                    color: var(--neutrals-grey-02, grey);
                    font-size: 16px;
                    font-family: MaerskText;
                    line-height: 20px;
                    font-weight: 400;
                    margin-top: 20px;
                    margin-bottom: 10px;
                }
                .desc {
                    color: var(--neutrals-grey-02, grey);
                    font-size: 14px;
                    font-family: MaerskText;
                    line-height: 20px;
                    margin-bottom: 24px;
                }
                .desc span {
                    text-decoration: underline;
                    cursor: pointer;
                }
                .dropdown {
                    box-sizing: border-box;
                    min-height: 41px;
                    border: 1px solid var(--neutrals-grey-06, grey);
                    border-radius: 2.5px;
                    font-family: MaerskText;
                    font-size: 14px;
                    color: var(--neutrals-grey-02, black);
                    background-color: var(--neutrals-grey-10, white);
                    text-indent: 5px;
                    width: 100%;
                    width: 394px;
                    margin-bottom: 10px;
                    border-radius: 6px;
                }

                .dropdown[disabled] {
                    background-color: var(--neutrals-grey-08, black);
                }
                .dropdown[error] {
                    border-color: #b80012;
                }
                #alarm-popup #footer {
                    display: flex;
                    justify-content: flex-end;
                    padding: 12px;
                    background: #f7f7f7;
                }

                .title {
                    margin-top: 0px;
                    font-family: MaerskText;
                }

                #alarm-popup #footer button {
                    height: 35px;
                    min-width: 80px;
                    font-size: 14px;
                    font-family: MaerskText;
                    background: none;
                    border: none;
                    outline: none;
                    cursor: pointer;
                    border-radius: 3px;
                    width: auto;
                }

                #alarm-popup #footer .do-it-later-button {
                    color: var(--neutrals-grey-02);
                    margin-right: 10px;
                    border: 1px solid var(--neutrals-grey-06, grey);
                    display: flex;
                    line-height: 28px;
                }

                #alarm-popup #footer .submit-button {
                    margin-right: 20px;
                    border-radius: 6px;
                }

                .comment-input {
                    width: 100%;
                    position: realtive;
                }

                .max-width-container {
                    width: 100%;
                }
                .center {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                }
                .error-message {
                    color: #b80012;
                    line-height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    margin-top: -5px;
                }
                .comment-input > textarea {
                    white-space: normal;
                    padding-left: 10px;
                    font-family: MaerskText;
                }

                .mdc-dialog__content{
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    overflow-y: auto;
                    justify-content: space-between;
                }

                .modal-footer {
                    margin: -30px;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    padding-bottom: 0px;
                    height: 64px;
                    background: #f7f7f7;
                    border-bottom-left-radius: 6px;
                    border-bottom-right-radius: 6px;
                    position: absolute;
                    bottom: 30px;
                    left: 30px;
                    width: 100%;
                }
                .footer-button{
                    margin-right: 25px;
                }
                .footer {
                    text-align: end;
                    padding: 16px 24px;
                    margin: -24px;
                    margin-top: 20px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    align-items: center;
                    padding-bottom: 0px;
                    gap: 12px;
                    height: 64px;
                    background: #f7f7f7;
                    border-bottom-left-radius: 6px;
                    border-bottom-right-radius: 6px;
                }
                .footer-button {
                    background-color: #ffffff;
                }

                .padding-top {
                    padding-top: 20px;
                }

                .center{
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        text-align: center;
                    }

                mc-modal::part(container) {
                    z-index: 9999;
                }
            `,
        ]
    }

    @property({ type: Boolean }) _shown: boolean = false
    @property({ type: Boolean }) _loading: boolean = false
    @property({ type: Boolean }) _shownSuccessPopup: boolean = false
    @property({ type: String }) _description: string = ''
    @property({ type: String }) private _comment: string | null = null
    private _showError: boolean = false
    private _title : string = WR_REJECT_TITLE;
    private _plan: VoyagePlan | null = null


    async _setPopupVisibility(e: Event) {

        const plan = await VesselPlanningModel!.getCurrentPlan((e as CustomEvent).detail.scheduleId);
        if (!plan) {
            console.error('No executing plan found')
            return
        }

        this._plan = plan;
        this._shown = (e as CustomEvent).detail.show
    }

    render() {
        if (this._shownSuccessPopup) {
            return html`${this._renderSubmitSuccessModal()}`
        }

        return html`${this._renderReasonSubmitModal()}`
    }

    private _renderSubmitSuccessModal() {
        return html`
            <voyage-popup id="alarm-popup" ?noCloseButton = ${true} ?noHeader = ${true}
                ?shown=${this._shownSuccessPopup}>
                <div id="success-topContainer">
                    <div class="max-width-container">
                        <div class="success-innerContainer">
                            <div>
                                <span>${SvgIcons.tickMark}</span>
                            </div>
                            <div class="content">
                                <h4 class ="title">Thank you!</h4>
                                <div class="desc">${SUCCES_MODAL_CONTENT}</div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                    <div id="footer" slot="footer">
                         <mc-button  class="submit-button"  appearance="primary" variant="filled" @click=${() => this._shownSuccessPopup = false} >Close</mc-button>
                 </div>
            </voyage-popup>
        `
    }

    private _onCancel() {
        this._shown = false
        VesselClfPopupModel!.dispatchEvent(new CustomEvent(WR_UPDATE_POPUP_CANCEL_CLICKED));
    }

    private async _onSubmit() {

        
        if (!this._comment) {
            this._showError = true
            this.requestUpdate()
            return
        }  
        this._loading = true;

        if (!this._plan) {
            console.error('No plan found for the selected scheduleId')
            this._loading = false;
            return
        }

        if(this._plan.selectedRouteIndex !== -1 && this._plan.routes[this._plan.selectedRouteIndex]?.weatherRoutingInfo){
            this._plan.routes[this._plan.selectedRouteIndex].weatherRoutingInfo!.required_reason = 'Manual';
            this._plan.routes[this._plan.selectedRouteIndex].weatherRoutingInfo!.required = true;
            this._plan.routes[this._plan.selectedRouteIndex].weatherRoutingInfo!.remarks = this._comment;
            this._plan.routes[this._plan.selectedRouteIndex].weatherRoutingInfo!.requested_at = new Date().toISOString();
            this._plan.routes[this._plan.selectedRouteIndex].weatherRoutingInfo!.updated_at_reason = 'Manual';
            this._plan.routes[this._plan.selectedRouteIndex].weatherRoutingInfo!.updated_at = new Date().toISOString();
            this._plan.routes[this._plan.selectedRouteIndex].weatherRoutingInfo!.status = WRStatus.Read;
        }

        await VesselPlanningModel!.setPlan(this._plan.scheduleId,this._plan, true, true);

        this._loading = false;

        this._shown = false
        VoyageToastManager.createToast({
            message: WRMessageTypes.UpdateRequest,
            type: 'success',
        })
    }

    private _renderReasonSubmitModal() {
        return html`<mc-modal
            heading=${this._title}
            ?open=${this._shown}
            dimension="small"
            width="450px"
            height="350px"
            backdropcloseactiondisabled
            escapecloseactiondisabled
            entercloseactiondisabled
            hiddenclose
        >
            ${this._renderModalContent()}
        </mc-modal> `
    }

    private _renderModalContent() {
        return html`
            ${this._loading
            ? html`<div class="center">
                    loading...
                </div>` : html`
                <div>
            <div class="desc">${WR_REJECT_DESCRIPTION}</div>
            <div class="comment-input">
                <div class="name">
                    Type your reason
                </div>
                <textarea
                    class="comment"
                    type="text"
                    placeholder="Write your reason or notes"
                    @input=${(e: Event) => this._comment = (e.target as HTMLTextAreaElement).value}
                ></textarea>
                ${(!this._comment && this._showError)
                ? html`<div class="error-message">
                          Please provide a reason
                      </div>`
                : html``}
            </div>
            <div class="modal-footer">
                <mc-button
                    class="footer-button"
                    appearance="neutral"
                    variant="filled"
                    @click=${this._onCancel}
                    >Cancel</mc-button>
                <mc-button
                    class="footer-button"
                    focusstartanchor
                    appearance="primary"
                    variant="filled"
                    @click=${this._onSubmit}
                    >Request</mc-button
                >
            </div>
        </div>
                `
                }
        `
    }
}
